import { Controller } from "stimulus";

const PUBLIC_KEY_TYPES = ['sso_idp_certificate', 'sso_sp_certificate', 'ssh_sftp_key', 'pgp_key'];
const PRIVATE_KEY_TYPES = ['sso_sp_certificate', 'ssh_sftp_key'];

export default class extends Controller {
  static targets = [
    'keyType',
    'publicKeyFields',
    'privateKeyFields',
    'publicKeyUpload',
    'publicKeyPaste',
    'privateKeyUpload',
    'privateKeyPaste',
  ];

  connect() {
    this.toggleKeyFields();
  }

  toggleKeyFields() {
    if (!this.hasKeyTypeTarget) return;

    const keyType = this.keyTypeTarget.value;

    this.publicKeyFieldsTarget.classList.toggle('hidden', !PUBLIC_KEY_TYPES.includes(keyType));
    this.privateKeyFieldsTarget.classList.toggle('hidden', !PRIVATE_KEY_TYPES.includes(keyType));
  }

  toggleKeyInput(event) {
    const select = event.currentTarget;
    const pasteMode = select.value === 'text';
    const prefix = select.dataset.keyField === 'private_key' ? 'privateKey' : 'publicKey';
    const uploadField = this[`${prefix}UploadTarget`];
    const pasteField = this[`${prefix}PasteTarget`];

    uploadField.classList.toggle('hidden', pasteMode);
    pasteField.classList.toggle('hidden', !pasteMode);

    if (pasteMode) {
      uploadField.querySelector('input[type="file"]').value = '';
    }
    else {
      pasteField.querySelector('textarea').value = '';
    }
  }
}
